import React from "react"

import PlacesAutocomplete from "../../components/shared/PlacesAutocomplete"
import { stripUSAFromString } from "../../utils/utils"

const LocationInput = ({ eventType, setEventType }) => {
  const onPlaceSelected = (place) => {
    // Update the location information
    const formattedAddress = place.formatted_address || ""
    setEventType((prev) => ({ ...prev, location: formattedAddress }))
  }

  return (
    <div>
      <PlacesAutocomplete
        apiKey={process.env.GOOGLE_MAPS_API_KEY}
        onPlaceSelected={onPlaceSelected}
        defaultValue={stripUSAFromString(eventType.location || "")}
        placeholder="Enter address"
      />
    </div>
  )
}

export default LocationInput
